import get from 'lodash/get';
import s from './CinemasWidget.module.scss';
import { getCinemaDetailsUrl, getCityCinemasUrl } from '../../services/urlCreator';
import { parseCityCinemas } from '../../selectors/moviesCityPageSelector';
import { isH5Container } from '../../services/h5Service';
import { useAppDispatch, useAppSelector } from '../../hooks/hooks';
import { cityCinemasSelector } from '../../redux/slices/movies/selectors';
import HorizontalLinksWidget from '../../components/HorizonatalLinksWidget/HorizontalLinksWidget';
import { useEffect } from 'react';
import { fetchCityCinemas } from '../../redux/slices/movies/fetcher';
interface Props {
	heading?: string;
	cityName: string;
	itemClickEvent?: any;
	viewAllClickEvent?: any;
	noPadding?: boolean;
	showHeaderActionLabel?: any;
}
const CinemasWidget = ({
	heading,
	cityName,
	itemClickEvent,
	viewAllClickEvent,
	noPadding = false,
	showHeaderActionLabel = true,
}: Props) => {
	const cinemasData = useAppSelector(cityCinemasSelector);

	const dispatch = useAppDispatch();
	useEffect(() => {
		dispatch(fetchCityCinemas({ cityName }));
	}, [cityName, dispatch]);

	if (!cinemasData || !cinemasData[cityName] || !cinemasData[cityName].data) return null;

	const cinemas = parseCityCinemas(cinemasData[cityName]?.data?.cinemas);
	const cinemaItems = cinemas
		.map(createCinemaItemsForHZWidget(isH5Container(), itemClickEvent, cityName))
		.slice(0, 10);
	const headerActionUrl = cityName ? getCityCinemasUrl(cityName) : '';
	const headerActionLabel = 'View All';

	if (!get(cinemas, 'length')) return null;
	return (
		<>
			<div className={s.grayBorder} />
			<HorizontalLinksWidget
				items={cinemaItems}
				heading={heading || `Popular cinemas`}
				headerActionLabel={headerActionLabel}
				headerActionUrl={headerActionUrl}
				showHeaderActionLabel={showHeaderActionLabel}
				labelProp="children"
				labelPrefix=""
				labelSuffix=""
				viewAllClickEvent={viewAllClickEvent}
				href={false}
				headerActionHref={false}
				noPadding={noPadding}
			/>
		</>
	);
};

function createCinemaItemsForHZWidget(isH5: boolean, clickEvent: any, cityName: string) {
	return (cinema: any) => {
		const { uniqueKey, userPref, label, id } = cinema;
		const isUserPref = userPref && !isH5;
		const children = isUserPref ? `Preferred ${label}` : label;
		const cinemaUrl = getCinemaDetailsUrl({ cityName, cinemaName: label, cinemaId: id });

		return {
			to: cinemaUrl,
			key: uniqueKey,
			children,
			clickEvent: () => {
				clickEvent && clickEvent(cinema);
			},
		};
	};
}

export default CinemasWidget;
